var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tianai-captcha-mask"},[_c('div',{ref:"captchaRoot",staticClass:"tianai-captcha-wrapper"})])
}
var staticRenderFns = []

export { render, staticRenderFns }